import { TrackJS } from 'trackjs';
import { TrackJSConfig } from '../../exception-tracking/trackjs.interface';
import { TrackJsConfigService } from '../track-js-config.service';

export function installTrackJS(trackJSConfigService: TrackJsConfigService) {
  return async () => {
    const [env]: TrackJSConfig[] = trackJSConfigService
      .getTrackJsConfig()
      .filter(({ name }) => name === document.location.hostname)
      .map((config: TrackJSConfig) => {
        delete config.name;
        return config;
      });
    await TrackJS.install(env);
  };
}
